import jQuery from 'jquery';
let $ = jQuery;

import "LIBS/jquery.menu-aim.js";

// define EVENTs
import "HSNDIR/Flyout.js";

    
HSN.HamburgerFlyout = function(config) {
    var scope = this;

    config = (config || {});
    config.closeTag = (config.closeTag = config.closeTag || 'span');

    this._application = config.application;
    this.Trigger = $(config.trigger);
    this.Flyout = $(config.flyout);
    this.FlyoutContent = $(config.flyoutContent);
    this.delayMouseLeave = 500;
    this.mouseLeaveFunction = null;
    this.autoLeaveFunction = null;
    this.isMouseOverFlyout = false;
    this.storefrontFlyout = null;
    this.cmPage = 'Bag';
    this.cmCategory = 'Flyout';
    this.touchTimeOut = null;

    this.Trigger.on('click mouseenter', function(e) {
        scope.OpenHamburgerMenu();

        window.clearTimeout(scope.mouseLeaveFunction);
        window.clearTimeout(scope.autoLeaveFunction);
        window.clearTimeout(scope.touchTimeOut);

        return true;
    });

    $('#hamburger-open-button').on('touchstart', function(e) {
        if(scope.GetState() === HSN.Flyout.STATE.CLOSED) {
            e.stopPropagation();
            scope.OpenHamburgerMenu();

            scope.isMouseOverFlyout = true;

            window.clearTimeout(scope.mouseLeaveFunction);
            window.clearTimeout(scope.autoLeaveFunction);
            window.clearTimeout(scope.touchTimeOut);

            return false;
        }
        else {
            e.stopPropagation();
            scope.Close();

            return false;
        }
    });

    this.Trigger.on('mouseleave', function() {
        scope.mouseLeaveFunction = window.setTimeout(function() {
            if(!scope.isMouseOverFlyout) {
                scope.Close();
            }
        }, scope.delayMouseLeave);
        return false;
    });

    this.Flyout.on('click touchstart', function(e) {
        window.clearTimeout(scope.autoLeaveFunction);
    });

    this.Flyout.on('mouseenter', function(e) {
        scope.isMouseOverFlyout = true;
    });

    this.Flyout.on('mouseleave', function(e) {
        scope.isMouseOverFlyout = false;

        scope.mouseLeaveFunction = window.setTimeout(function() {
            scope.Close();
        }, scope.delayMouseLeave);
        return false;
    });

};
HSN.HamburgerFlyout.prototype = {
    _state : HSN.Flyout.STATE.CLOSED,
    GetState : function() {
        return this._state;
    },
    Close : function() {
        var scope = this;
        if(scope._state === HSN.Flyout.STATE.CLOSED) {
            return;
        }
        scope._application.Events.Trigger(HSN.Flyout.EVENT.BEFORE_CLOSE, scope);

        //$(document).off('touchstart', '#modal-mask', scope.TouchOut);
        //$(document).off('touchstart', scope.TouchOut);

        if($('.modal:visible').length < 1) {
            $('#modal-mask').remove();
        }

        if(scope.storefrontFlyout) {
            scope.storefrontFlyout.hide();
        }

        scope.Flyout.hide();
        scope._state = HSN.Flyout.STATE.CLOSED;

        var hamburger = scope.Flyout.find('#hamburger');

        hamburger.removeClass('open');
        hamburger.find("li").removeClass("active");
    },
    OpenHamburgerMenu : function() {
        var scope = this;
        if(scope._state === HSN.Flyout.STATE.OPEN) {
            return;
        }

        scope._application.Events.Trigger(HSN.Flyout.EVENT.BEFORE_OPEN, scope);
        scope._state = HSN.Flyout.STATE.OPEN;

        var pos = scope.Trigger.position();
        scope.Flyout.css({
            'top' : this.Trigger.height() + pos.top,
            'left' : pos.left
        });

        if(!$('#modal-mask').is(':visible')) {
            $('<div></div>').prependTo('#torso').attr('id', 'modal-mask').addClass('lower-mask');
        }

        if(!$('#modal-mask').is(':visible')) {
            $('#modal-mask').css('height', $('body').height());
            $('#modal-mask').show();
        }

        scope.Flyout.css('display', 'table');
            
        scope.Flyout.find('#hamburger').menuAim({
            rowSelector: 'li',
            activate: function (row) {
                var $row = $(row);
                var id = $row.data('marketingId');
                scope.OpenStorefrontFlyout(id);

                if (Modernizr.touchevents) {
                    if($row.find('a').hasClass('current')) {
                        return true;
                    }
                }

                $row.addClass("active");
            },

            deactivate: function(row) {
                scope.RemoveActiveFlyout();
                $(row).removeClass("active");
            }
        });

        $(document).one('touchstart', '#modal-mask', function(event) {
            event.stopPropagation();

            scope.isMouseOverFlyout = false;
            scope.Close();

            return false;
        });
    },
    OpenStorefrontFlyout: function(id) {
        this.storefrontFlyout = $('#hamburger-storefront-flyout');
        this.storefrontFlyout.find('> div:visible').hide();
        this.storefrontFlyout.find('#storefront-' + id).show();
        this.storefrontFlyout.show();
    },

    RemoveActiveFlyout: function () {
        this.Flyout.find('a').each(function () {
            $(this).removeClass('current');
        });
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/HamburgerFlyout.js